import React from 'react'
import { ApprovalCommentRow } from './ApprovalCommentRow'
import type { CommentDayGroup } from './types'

interface Props {
  group: CommentDayGroup
}

export const ApprovalCommentDayGroup: React.FC<Props> = ({ group }) => (
  <div className="flex flex-col">
    <div className="flex items-center justify-between gap-2 border-b border-[#E1E1E1] bg-quaternary px-6 py-2 text-xs font-bold tracking-[0.3px] text-[#363639]">
      <span>{group.dayLabel}</span>
      {group.userName && (
        <span className="font-medium tracking-normal text-[#5C5C72]">
          {group.userName}
        </span>
      )}
    </div>
    {group.items.map(entry => (
      <ApprovalCommentRow key={entry.id} entry={entry} />
    ))}
  </div>
)
